import React, { useState, useEffect, useCallback, useRef } from "react";

// Redux
import { useSelector, useDispatch } from 'react-redux';
import { removeProduct, removeService } from '../../stores/cartSlice';
import { showModal } from "../../stores/modalSlice";

// Components
import CardLabelComponent from "../../components/CardLabelComponent";
import CardDataLabelComponent from "../../components/CardDataLabelComponent";
import CategoryIcons from "../../components/CategoryIcons";
import SwitchComponent from "../../components/SwitchComponent";
import ButtonFullComponent from "../../components/ButtonFullComponent";
import PaymentModalComponent from "../../components/payment/PaymentModalComponent";
import PaymentResumeModalComponent from "../../components/payment/PaymentResumeComponent";

// Services
import { formatterService } from "../../services/formatters.service";
import { purchaseService } from "../../services/purchase.service";
import { showToast } from "../../stores/toastSlice";
import { locationService } from "../../services/location.service";

function OrderItemComponent(props) {
    const dispatch = useDispatch();

    const promotionalCodeRef = useRef(null);

    const [totalLoading, setTotalLoading] = useState(false);
    const [purchaseLoading, setPurchaseLoading] = useState(false);
    const [discount, setDiscount] = useState(0);
    const [total, setTotal] = useState(0);

    const cart = useSelector((state) => state.cart);
    const paymentStore = useSelector((state) => state.payment);

    const [promotionalCode, setPromotionalCode] = useState(null);
    const [promotionalCodeApplied, setPromotionalCodeApplied] = useState({ invalid: false, applied: null });

    const [condition, setCondition] = useState(false);
    const [purchaseButtonEnabled, setPurchaseButtonEnabled] = useState(false);

    const [modalPayment, setModalPayment] = useState({
        show: false, paymentData: {
            orderId: 0,
            products: [],
            ladder: "false",
            disassemble: "false",
            address: "",
            discount: 0,
            total: 0
        }
    });
    const [modalResume, setModalResume] = useState({ show: false });

    const simulatePurchase = useCallback(async () => {
        if (cart.products && cart.products?.length > 0) {
            setTotalLoading(true);
            try {

                var products = cart.products.map((product) => {
                    return { catalog_id: product.id, quantity: product.quantity };
                });

                const ladder = cart.additionalServices.findIndex(x => x.value == 1) !== -1;
                const disassemble = cart.additionalServices.findIndex(x => x.value == 2) !== -1;

                const payload = {
                    products: products,
                    ladder: ladder.toString(),
                    disassemble: disassemble.toString(),
                    promotional_code: promotionalCode || promotionalCodeApplied.applied
                };

                var simulateResponse = await purchaseService.simulatePurchase(payload);

                if (simulateResponse) {
                    if (simulateResponse.message) {
                        throw simulateResponse.message;
                    }

                    if (simulateResponse.total)
                        setTotal(Number(simulateResponse.total));
                    else
                        setTotal(0);

                    if (simulateResponse.discount && promotionalCode) {
                        setDiscount(Number(simulateResponse.discount));
                        setPromotionalCodeApplied((prevState) => ({
                            ...prevState,
                            applied: promotionalCode,
                            invalid: false
                        }));

                    }
                    else {
                        if (promotionalCode) {
                            setPromotionalCodeApplied((prevState) => ({
                                ...prevState,
                                applied: '',
                                invalid: true
                            }));
                        }
                        else {
                            setPromotionalCodeApplied((prevState) => ({
                                ...prevState,
                                invalid: false
                            }));
                        }
                    }
                }


            } catch (error) {
                dispatch(showModal({ title: "Atenção", message: error, show: true, showWhats: true }));

                console.error("Erro ao simular o total", error);
            }
            finally {
                setTotalLoading(false);
            }
        }
        else {
            setTotal(0);
            setDiscount(0);
        }
    }, [cart.products, cart.additionalServices, promotionalCode, promotionalCodeApplied.applied, dispatch]);

    useEffect(() => {
        simulatePurchase();
    }, [simulatePurchase]);

    const purchase = async () => {

        var validated = await validatePurchaseData();

        if (validated) {

            setPurchaseLoading(true);
            try {

                var products = cart.products.map((product) => {
                    return { catalog_id: product.id, quantity: product.quantity };
                });

                const ladder = cart.additionalServices.findIndex(x => x.value == 1) !== -1;
                const disassemble = cart.additionalServices.findIndex(x => x.value == 2) !== -1;

                var date = new Date(cart.date);

                var payload = {
                    period_id: cart.form.period,
                    residence_type_id: cart.form.local,
                    first_name: cart.form.firstName,
                    last_name: cart.form.lastName,
                    cpf: cart.form.doc,
                    telephone: cart.form.phone,
                    email: cart.form.email,
                    zip_code: cart.form.zipCode,
                    street: cart.form.address,
                    neigh: cart.form.neigh,
                    city: cart.form.city,
                    state: cart.form.state,
                    number: cart.form.number,
                    complement: cart.form.complement,
                    reference: cart.form.reference,
                    responsible: cart.form.responsible,
                    observation: cart.form.obs,
                    schedule_request_date: date.toString(),
                    ladder: ladder.toString(),
                    disassemble: disassemble.toString(),
                    promotional_code: promotionalCode || promotionalCodeApplied.applied,
                    products: products,
                };

                var purchaseResponse = await purchaseService.purchase(payload);

                if (purchaseResponse) {

                    if (purchaseResponse.message) {
                        throw purchaseResponse.message;
                    }


                    if (purchaseResponse?.service_order_id) {
                        var paymentData = {
                            orderId: purchaseResponse?.service_order_id,
                            products: products,
                            ladder: ladder.toString(),
                            disassemble: disassemble.toString(),
                            address: `${cart.form.address}, ${cart.form.number}, ${cart.form.zipCode}`,
                            discount: discount,
                            total: total
                        }
                        setModalPayment({ show: true, paymentData: paymentData });
                    }
                }
                else {

                }

            } catch (error) {

                dispatch(showModal({ title: "Atenção", message: error, show: true, showWhats: true }));

                console.error("Erro ao enviar para pagamento", error);
            }
            finally {
                setPurchaseLoading(false);
            }
        }
    };

    const handlePaymentStatus = () => {
        setModalResume({ show: true });
    };

    const validatePurchaseData = async () => {

        if (!cart.form.local) {
            dispatch(showToast({ message: "Informe qual local será retirado!", color: 'warning' }));
            return false;
        }

        if (!cart.date) {
            dispatch(showToast({ message: "Informe a data da coleta!", color: 'warning' }));
            return false;
        }

        if (!cart.form.period) {
            dispatch(showToast({ message: "Informe o período da coleta!", color: 'warning' }));
            return false;
        }

        if (!cart.form.zipCode) {
            dispatch(showToast({ message: "Informe o CEP!", color: 'warning' }));
            return false;
        }
        else {

            if (cart.form.city) {
                var distance = await locationService.fetchDistanceByCity(cart.form.city);
                if (distance > process.env.REACT_APP_DISTANCE_LIMIT) {
                    let title = "Aviso sobre a distância";
                    let message = `Para distâncias maiores que ${process.env.REACT_APP_DISTANCE_LIMIT} Km, é necessário entrar em contato através do botão abaixo.`;

                    dispatch(showModal({ title, message, show: true, showWhats: true }));

                    return false;
                }
            }
        }

        if (!cart.form.address) {
            dispatch(showToast({ message: "Informe o logradouro!", color: 'warning' }));
            return false;
        }

        if (!cart.form.number) {
            dispatch(showToast({ message: "Informe o número!", color: 'warning' }));
            return false;
        }

        if (!cart.form.neigh) {
            dispatch(showToast({ message: "Informe o bairro!", color: 'warning' }));
            return false;
        }

        if (!cart.form.firstName) {
            dispatch(showToast({ message: "Informe o Nome!", color: 'warning' }));
            return false;
        }

        if (!cart.form.lastName) {
            dispatch(showToast({ message: "Informe o Sobrenome!", color: 'warning' }));
            return false;
        }

        if (!cart.form.doc || !formatterService.validateCpf(cart.form.doc)) {
            dispatch(showToast({ message: "Informe um CPF válido!", color: 'warning' }));
            return false;
        }

        if (!cart.form.phone) {
            dispatch(showToast({ message: "Informe o telefone!", color: 'warning' }));
            return false;
        }

        if (!cart.form.email || !formatterService.validateEmail(cart.form.email)) {
            dispatch(showToast({ message: "Informe o email válido!", color: 'warning' }));
            return false;
        }


        return true;

    };

    const handleRemoveProduct = (id) => {
        if (!paymentStore.payed) {
            dispatch(removeProduct({ id }));

            if (cart.products.length === 0 || cart.products.length === 1) {
                setPromotionalCodeApplied((prevState) => ({
                    ...prevState,
                    applied: '',
                    invalid: false
                }));
            }
        }
    };

    const handleRemoveService = (id) => {
        if (!paymentStore.payed) {
            dispatch(removeService({ id }));
        }
    };

    const handleSetPromotionalCode = async () => {
        setPromotionalCode(promotionalCodeRef?.current?.value || null);
    };

    const handleConditionChange = (checked) => {
        setCondition(checked);
    };

    const handleCloseModal = () => {

        setModalPayment((prev) => ({
            ...prev,
            show: false
        }));

    };

    // Conditional Renders
    const renderAppliedPromotionalCode = () => {

        if (promotionalCodeApplied.invalid) {
            return (
                <div className="row">
                    <div className="col-1"></div>
                    <div className="col-11">
                        <label className="text-danger custom-labels">*Código promocional inválido</label>
                    </div>
                </div>
            );
        }
        else if (promotionalCodeApplied.applied) {
            return (
                <>
                    <div className="row mt-2">
                        <div className="col-1"></div>
                        <div className="col-7">
                            <CardDataLabelComponent label={"Código aplicado:"} bold={true} />
                        </div>
                        <div className="col-4" style={{textAlign: 'end'}}>
                            <CardDataLabelComponent label={promotionalCodeApplied.applied} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col-1"></div>
                        <div className="col-9">
                            <CardDataLabelComponent label="Desconto" bold={true} />
                        </div>
                        <div className="col-2" style={{ textAlign: 'end' }}>
                            <CardDataLabelComponent label={formatterService.toPercent(discount)} bold={false} />
                        </div>
                        <div className="col-2">

                        </div>
                    </div>
                </>
            )
        }
    };

    const validateEnablePurchase = useCallback(() => {
        if (paymentStore.payed)
            return false;

        return cart.products?.length > 0 && condition;
    }, [cart.products, condition, paymentStore.payed]);

    const handlePaymentExecuted = () => {
        window.location.reload();
    };


    useEffect(() => {
        setPurchaseButtonEnabled(validateEnablePurchase());
    }, [cart.products, condition, paymentStore.payed, validateEnablePurchase]);


    return (
        <>
            <div className="container" >

                {!cart.products || cart.products?.length === 0 ? (
                    <div className="row">
                        <div className="col-1 mt-2">
                        </div>
                        <div className="col-7">
                            <CardLabelComponent label="Produto:" />
                        </div>

                        <div className="col-3">
                            <CardLabelComponent label="Quantidade:" />
                        </div>
                        <div className="col-1 mt-4" style={{ paddingTop: '5px', cursor: 'pointer' }}>
                        </div>
                    </div>

                ) : ("")}

                {cart.products && cart.products.map((item, index) => (
                    <div className="row" key={index}>
                        <div className="mt-1 col-1">
                            <CategoryIcons width={25} height={25} icon={item.icon_definition} />
                        </div>
                        <div className="col-7">
                            <CardLabelComponent label="Produto:" />
                            <CardDataLabelComponent label={item.name} bold={true} />
                        </div>

                        <div className="col-3 text-center">
                            <CardLabelComponent label="Qtde:" />
                            <CardDataLabelComponent label={item.quantity} bold={true} />
                        </div>
                        <div className="col-1 mt-4" style={{ paddingTop: '5px', cursor: 'pointer' }} disabled={paymentStore.payed} onClick={() => handleRemoveProduct(item.id)} >
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                <path d="M9.94922 1.6885L6.60925 5.03851L9.94922 8.3785L8.79919 9.53851L5.44922 6.19851L2.10925 9.53851L0.949219 8.3785L4.29919 5.03851L0.949219 1.6885L2.10925 0.528503L5.44922 3.8785L8.79919 0.528503L9.94922 1.6885Z" fill="black" />
                            </svg>
                        </div>
                    </div>

                ))}


                {cart.products && cart.products?.length > 0 ? (
                    <div className="row">
                        <div className="col-1"></div>
                        <div className="col-11"><hr /></div>
                    </div>
                ) : (

                    <div className="row" style={{ height: '200px' }}>
                        <div className="col-1"></div>
                        <div className="col-11"><hr /></div>
                    </div>

                )}

                {cart.additionalServices && cart.additionalServices?.length > 0 ? (
                    <React.Fragment>
                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-11"><CardLabelComponent label="Serviços adicionais:" /></div>
                        </div>

                        {cart.additionalServices && cart.additionalServices?.map((item, index) => ((
                            <div className="row" key={index}>
                                <div className="col-1"></div>
                                <div className="col-8">
                                    <CardDataLabelComponent label={item.text} bold={true} />
                                </div>
                                <div className="col-2">

                                </div>
                                <div className="col-1" style={{ paddingTop: '5px', cursor: 'pointer' }} disabled={paymentStore.payed} onClick={() => handleRemoveService(item.value)} >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
                                        <path d="M9.94922 1.6885L6.60925 5.03851L9.94922 8.3785L8.79919 9.53851L5.44922 6.19851L2.10925 9.53851L0.949219 8.3785L4.29919 5.03851L0.949219 1.6885L2.10925 0.528503L5.44922 3.8785L8.79919 0.528503L9.94922 1.6885Z" fill="black" />
                                    </svg>
                                </div>
                            </div>
                        )))}

                        <div className="row">
                            <div className="col-1"></div>
                            <div className="col-11"><hr /></div>
                        </div>

                    </React.Fragment>

                ) : ("")}

                {cart.products && cart.products?.length > 0 ? (
                    <React.Fragment>
                        {!promotionalCodeApplied.applied ? (
                            <div className="row">
                                <div className="col-1"></div>
                                <div className="col-11">
                                    <CardDataLabelComponent label="Insira o código promocional" bold={true} />


                                    <div className="input-group">
                                        <input ref={promotionalCodeRef} type="text" className={`form-control input-termos`} />
                                        <div className="input-group-append">
                                            <button className="btn custom-btn btn-termos " disabled={paymentStore.payed} onClick={async () => handleSetPromotionalCode()}>OK</button>
                                        </div>
                                    </div>


                                </div>
                            </div>) : ("")}

                        {renderAppliedPromotionalCode()}

                    </React.Fragment>
                ) : ("")}

                <div className="p-2"><hr style={{ border: "1px solid #000" }} /></div>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                    <CardDataLabelComponent label="Total" title={true} bold={true} />
                    {totalLoading ? (
                        <div className="px-2">
                            <div className="spinner-border text-success" role="status">
                                <span className="sr-only"></span>
                            </div>
                        </div>) : (
                        <CardDataLabelComponent label={formatterService.toPtCurrency(total)} title={true} bold={true} color={"#005E2C"} />
                    )}
                </div>

                <div className="mt-1">
                    <SwitchComponent id="swtCondition" label="Estou ciente das condições gerais" disabled={(!paymentStore.payed && cart.products?.length === 0) || paymentStore.payed} onSwitchChange={handleConditionChange} />
                </div>
                <div className="mt-3">
                    <ButtonFullComponent text="Pague com segurança" id="btnPurchase" disabled={!purchaseButtonEnabled} loading={purchaseLoading} handleClick={purchase} />
                </div>

                {paymentStore.payed && (
                    <div className="mt-3 text-confirm">
                        *O Pagamento deste pedido já foi realizado!
                    </div>
                )}
            </div>

            <PaymentModalComponent
                show={modalPayment.show}
                paymentData={modalPayment.paymentData}
                showPaymentStatus={handlePaymentStatus}
                handleClose={handleCloseModal}
            />

            <PaymentResumeModalComponent
                show={modalResume.show}
                handleClose={handlePaymentExecuted}
            />
        </>
    );
}

export default OrderItemComponent;






